/**
 * Safe Base64 decoding that handles UTF-8 characters properly
 * Prevents issues with non-ASCII characters like special characters or emojis
 */
export function fromBase64(base64: string): string {
  try {
    return decodeURIComponent(
      Array.prototype.map
        .call(atob(base64), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
  } catch {
    // Fallback to simple atob if decoding fails
    try {
      return atob(base64);
    } catch {
      return '';
    }
  }
}

/**
 * Safe Base64 encoding that handles UTF-8 characters properly
 */
export function toBase64(str: string): string {
  try {
    const bytes = new TextEncoder().encode(str);
    let binary = '';
    for (const b of bytes) {
      binary += String.fromCharCode(b);
    }
    return btoa(binary);
  } catch {
    // Fallback to simple btoa if encoding fails
    try {
      return btoa(str);
    } catch {
      return '';
    }
  }
}
